export default __webpack_public_path__ + "static/media/ceu-nuvens.a991e143.svg";